import {
  Component,
  AfterViewInit,
  AfterViewChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { resolve } from 'dns';
import {
  API_URL_APPLICATIONS_FILES,
  COOPERATIONS,
  COOPERATION_UPLOAD,
  COOPERATION_DETAIL,
  COOPERATION_PERIOD_CHECK,
} from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {
  CONSTANT,
  IMAGE_EXTENSION,
  LOADING_KEY,
  NUMBER,
} from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-h101',
  templateUrl: './h101.component.html',
  styleUrls: ['./h101.component.scss', '../platform.component.scss'],
})

/**
 * 連携事例登録(E101)
 */
export class H101Component extends PlatformComponent {
  // 画面.入力フォーム
  h101InputForm: FormGroup = this.formBuilder.group({
    // タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 取組概要
    attemptoverview: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'attemptoverview',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 事例イメージ１
    case_image1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image1',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 事例イメージ１キャプション
    case_image1_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image1_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 事例イメージ２
    case_image2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image2',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 事例イメージ１キャプション
    case_image2_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image2_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 都道府県
    prefectures: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'prefectures',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 地上公共団体等代表
    public_representative: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'public_representative',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 民間団体等代表
    private_representatibe: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'private_representatibe',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 他連携団体等
    other_cooperation: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'other_cooperation',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 事例タグ
    case_tag: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_tag',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // カテゴリ
    category: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'category',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 事業費
    business_cost: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'business_cost',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 目指すSDGsゴール
    sdgs_goal: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'sdgs_goal',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 連携開始時期
    coopstart_season: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'coopstart_season',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // この取組で解決した課題
    clear_agenda: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'clear_agenda',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 解決に向けた手法
    method: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'method',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 概要イメージ１
    overview_image1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image1',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 概要イメージ１キャプション
    overview_image1_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image1_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 概要イメージ２
    overview_image2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image2',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 概要イメージ２キャプション
    overview_image2_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image2_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 事業推進上の各団体の役割分担
    role_sharing: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'role_sharing',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 地域関係者との連携方法
    coop_method: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'coop_method',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 資金調達方法
    funding_plan: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'funding_plan',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 資金調達方法の補足
    funding_plan_supplement: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'funding_plan_supplement',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 事業推進上の困難・課題・解決方法
    solution: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'solution',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 担当者のコメント
    responsible_person_comment: this.formBuilder.control(
      CONSTANT.EMPTY_STRING,
      {
        asyncValidators: [
          this.validator.CheckValidator(
            'cooperation',
            'responsible_person_comment',
            INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
          ),
        ],
      }
    ),
    // 担当者写真
    responsible_person_image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'responsible_person_image',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 担当者キャプション
    responsible_person_caption: this.formBuilder.control(
      CONSTANT.EMPTY_STRING,
      {
        asyncValidators: [
          this.validator.CheckValidator(
            'cooperation',
            'responsible_person_caption',
            INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
          ),
        ],
      }
    ),
    // 公開設定
    cooperation_open: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'cooperation_open',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 団体名
    organization_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'organization_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 部署名
    divition_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'divition_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 担当者名
    responsible_person_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'responsible_person_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 電話番号
    tel: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'tel',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // メールアドレス
    email: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'email',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 地方創生SDGsの視点
    sdgs_perspective: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'sdgs_perspective',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // ステークホルダーとの連携
    coop_stakeholders: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'coop_stakeholders',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // モデル性・波及性
    model_nature: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'model_nature',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  // 連携事例IDを格納
  cooperationId: string = this.route.snapshot.queryParams.cooperation_id;

  // 連携事例応募期間フラグ
  cooperationPeriodCheck: string = 'false';

  // 取得辞書マスタコード
  getSpecCode: any = [3, 2017, 2018, 2019,10];

  prefectureIdCodeList: any;

  // 公開設定 初期値
  cooperation_open_default: string = '1';

  // 画像ID存在フラグ
  caseImgId1: boolean = false;
  caseImgId2: boolean = false;
  overviewImgId1: boolean = false;
  overviewImgId2: boolean = false;
  responsiblePersonImgId: boolean = false;

  // 画像情報保持
  searchResultsList: any;

  // 画面項目
  columnName = {
    title: 'タイトル',
    attemptoverview: '概要',
    case_image1: '図・写真①',
    case_image1_caption: '図・写真①タイトル',
    case_image2: '図・写真②',
    case_image2_caption: '図・写真②タイトル',
    prefectures: '都道府県',
    public_representative: '代表地方公共団体等',
    private_representatibe: '代表民間団体等',
    other_cooperation: '他の連携団体等',
    case_tag: '事例タグ',
    category: 'カテゴリ',
    business_cost: '事業費',
    sdgs_goal: '目指すSDGsゴール',
    coopstart_season: '事業化までの期間',
    clear_agenda: 'この取組で解決した課題',
    method: '解決に向けた手法',
    overview_image1: '図・写真③',
    overview_image1_caption: '図・写真③タイトル',
    overview_image2: '図・写真④',
    overview_image2_caption: '図・写真④タイトル',
    role_sharing: '事業推進上の各団体の役割分担',
    coop_method: '地域関係者との連携方法',
    funding_plan: '資金調達方法',
    funding_plan_supplement: '資金調達方法の補足',
    solution: '事業推進上の課題・工夫',
    responsible_person_comment: '担当者のコメント',
    responsible_person_image: '担当者等の写真等',
    responsible_person_caption: '写真等のタイトル',
    cooperation_open: '公開設定',
    organization_name: '団体名称（全角）',
    divition_name: '部局名（全角）',
    responsible_person_name: '氏名（全角）',
    tel: '電話番号（半角数字、ハイフン不要）',
    email: 'eメールアドレス',
    sdgs_perspective: '応募にあたっての記載事項',
  };

  // 必須項目
  requiredName = {
    title: 'タイトル',
    attemptoverview: '概要',
    case_image1: '図・写真①',
    case_image1_caption: '図・写真①タイトル',
    prefectures: '都道府県',
    public_representative: '代表地方公共団体等',
    private_representatibe: '代表民間団体等',
    other_cooperation: '他の連携団体等',
    case_tag: '事例タグ',
    category: 'カテゴリ',
    sdgs_goal: '目指すSDGsゴール',
    coopstart_season: '事業化までの期間',
    clear_agenda: 'この取組で解決した課題',
    method: '解決に向けた手法',
    coop_method: '地域関係者との連携方法',
    funding_plan: '資金調達方法',
    solution: '事業推進上の課題・工夫',
  };

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private cdr: ChangeDetectorRef,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを連携事例登録(H101)に変更する
    this.router.navigate(['pages/platform/h101/' + this.inputType], {
      queryParams: {
        screenId: 'h101',
        cooperation_id: this.cooperationId,
      },
    });
  }

  async ngOnInit(): Promise<void> {

    await this.getUserLogin();
    // 辞書値リストを取得
    this.getSpecCodeList(this.getSpecCode);

    // 課題カテゴリを取得
    this.getAgendaCategoryList();

    // 新規初期表示
    this.setNewInitialData();

    // 編集初期表示
    this.setEditInitialData();

    // 連携事例応募期間チェック
    this.getCooperationPeriodCheck();

    // 業務用辞書情報取得処理
    this.dbOperationService.getDicLists(10).subscribe((response) => {
      // 全辞書情報が存在するか否か
      if (!this.commonService.checkNoneResponse(response)) {
        // 辞書情報に存在する場合

        // 辞書情報を格納
        this.prefectureIdCodeList = response.body;
      } else {
        // 辞書情報に存在しない場合

        this.prefectureIdCodeList = null;
      }
    });
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });
  }

  ngAfterViewChecked(): void {
    // 図・写真① 必須入力判定
    this.checkRequiredImg1();
    this.cdr.detectChanges();
  }

  /**
   * 新規初期表示
   */
  private setNewInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.NEW == this.inputType)) {
      // 新規以外の場合
      return;
    }

    // 初期値セット
    this.commonService.setFormGroupInitialData(this.h101InputForm, {
      organization_name: this.loginUser.organization_name,
      divition_name: this.loginUser.division_name,
      responsible_person_name: this.loginUser.full_name,
      tel: this.loginUser.tel,
      email: this.loginUser.email,
    });
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(COOPERATION_DETAIL);

    // 連携事例詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(COOPERATION_DETAIL, this.cooperationId, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, COOPERATION_DETAIL);
        if (this.commonService.checkNoneResponse(response)) {
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        if(!this.decisionPerspective(response.body.member_id)
         && !this.decisionSecretariat()
        ){
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }

        // 項目が入力されていない場合エラーメッセージを表示
        this.displayRequiredError();

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.h101InputForm,
          response.body
        );

        {
          // 事例タグを配列で渡す
          if (response.body.case_tag.length != 0) {
            this.h101InputForm
              .get('case_tag')
              .setValue([response.body.case_tag]);
          } else {
            this.h101InputForm.get('case_tag').setValue([]);
          }

          //
          this.searchResultsList = response.body;
          // 画像ID存在フラグを設定する
          // 画像1
          if (
            response.body.case_image1.id != CONSTANT.EMPTY_STRING &&
            response.body.case_image1.id?.length != 0
          )
            this.caseImgId1 = true;
          // 画像2
          if (
            response.body.case_image2.id != CONSTANT.EMPTY_STRING &&
            response.body.case_image2.id?.length != 0
          )
            this.caseImgId2 = true;
          // 画像3
          if (
            response.body.overview_image1.id != CONSTANT.EMPTY_STRING &&
            response.body.overview_image1.id?.length != 0
          )
            this.overviewImgId1 = true;
          // 画像4
          if (
            response.body.overview_image2.id != CONSTANT.EMPTY_STRING &&
            response.body.overview_image2.id?.length != 0
          )
            this.overviewImgId2 = true;
          // 担当者画像
          if (
            response.body.responsible_person_image.id !=
              CONSTANT.EMPTY_STRING &&
            response.body.responsible_person_image.id?.length != 0
          )
            this.responsiblePersonImgId = true;
        }
      });
  }

  /**
   * ファイルアップロード
   * @param event ファイル情報
   * @param fileUpload ボタン動作状態
   * @param formName フォーム項目名
   */
  public uploadFile(event: any, fileUpload: any, formName: string) {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_APPLICATIONS_FILES);

    // ファイル情報からファイル名を取得
    const fileName = event.files[0].name;

    // 拡張子を取得
    const extension = event.files[0].name.substring(
      event.files[0].name.lastIndexOf(CONSTANT.PERIOD)
    );

    // 拡張子が".jpg" or ".jpeg" or ".png"か否か判定
    if (
      !(
        IMAGE_EXTENSION.JPG == extension ||
        IMAGE_EXTENSION.JPEG == extension ||
        IMAGE_EXTENSION.PNG == extension ||
        IMAGE_EXTENSION.JPG2 == extension ||
        IMAGE_EXTENSION.JPEG2 == extension ||
        IMAGE_EXTENSION.PNG2 == extension
      )
    ) {
      // 拡張子が".jpg" or ".jpeg" or ".png"
      // or".JPG" or ".JPEG" or ".PNG"以外の場合
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(
            MESSAGE_CODE.E00013,
            'jpg又はjpeg又はpng'
          ),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイルサイズの判定
    if (
      NUMBER.ZERO == event.files[0].size ||
      10485760 / 2 <= event.files[0].size
    ) {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // ファイルサイズが0KBの場合 または
      // 5MB以上の場合

      // 画像サイズエラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(
            MESSAGE_CODE.E00031,
            '5MB以内'
          ),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイル情報(base64)取得処理
    this.commonService.getBase64(event.files[0]).then((b64) => {
      const csize = 3000000; //3MBで分割
      var lc = Math.floor(b64.length / csize) + 1; //全ループ回数＝分割数
      var s: number;
      var e: number;
      var b64_konkai: string; //ループ毎に処理するbase64エンコード
      var b64_arr = new Array(); //バッファ

      //先頭部分の除去
      b64 = b64.replace(/^data:.*?;base64,/, '');

      for (var c = 0; c < lc; c++) {
        //開始Indexと終了Index
        s = c * csize;
        e = s + csize;
        if (e >= b64.length) {
          e = b64.length;
        }

        //バッファ配列にセット
        b64_konkai = b64.substring(s, e);
        b64_arr.push(b64_konkai);
      }

      // ファイル登録を実施 処理部分
      const file_register = (b64_arr: Array<any>, lc: number) => {
        return new Promise((resolve) => {
          this.dbOperationService
            .insertFileResult(
              API_URL_APPLICATIONS_FILES,
              fileName,
              b64_arr[0],
              1,
              lc
            )
            .subscribe((response) => {
              // 画面.入力フォームにファイルIDを格納
              this.h101InputForm.get(formName).setValue(response.body.file_id);

              // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
              this.h101InputForm.get(formName).markAsDirty();

              // 画像タイトル必須エラー設定
              this.checkRequiredImgCaption(formName);

              //分割2回目～
              if (lc >= 2) {
                var arr = new Array();
                for (var c = 2; c <= lc; c++) {
                  arr.push(c);
                }
                (async () => {
                  for await (var num of arr) {
                    const res = await file2_register(num);
                  }
                  resolve('ok');
                })();
              } else resolve('ok');

              const file2_register = (n: number) => {
                return new Promise((resolve2) => {
                  this.dbOperationService
                    .insertFileResult(
                      API_URL_APPLICATIONS_FILES,
                      fileName,
                      b64_arr[n - 1],
                      n,
                      lc
                    )
                    .subscribe((response) => {
                      resolve2(response.body);
                    });
                });
              };
            });
        });
      };

      // ファイル登録を実施
      (async () => {
        const f_s = await file_register(b64_arr, lc);
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);
      })();
    });

    // 初期画像表示ID削除
    this.breakImgCaptionFlg(formName);
  }

  /**
   * アップロードファイル削除
   * @param formName フォーム項目名
   */
  public deleteFile(formName: string) {
    // 画面.入力フォームからファイル情報を削除
    this.h101InputForm.get(formName).setValue(CONSTANT.EMPTY_STRING);

    // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
    this.h101InputForm.get(formName).markAsDirty();

    // 画像タイトル必須エラー設定
    this.checkRequiredImgCaption(formName);

    // 初期画像表示ID削除
    this.breakImgCaptionFlg(formName);
  }

  /**
   * 連携事例応募期間チェック
   */
  public getCooperationPeriodCheck() {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(COOPERATION_PERIOD_CHECK);

    // 未承認一覧（連携事例）結果を取得
    this.dbOperationService
      .getNoTemplateData(COOPERATION_PERIOD_CHECK)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.cooperationPeriodCheck = response.body.iswithin_appliperiod;
        } else {
          this.cooperationPeriodCheck = 'false';
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, COOPERATION_PERIOD_CHECK);
      });
  }

  /**
   * 連携事例詳細(H301)を表示する
   */
  public moveH301(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let h101InputForm: any = JSON.parse(
      JSON.stringify(this.h101InputForm.value)
    );
    // 登録前変換
    {
      // 配列をカンマ区切り変換
      // 関連するゴール
      h101InputForm.sdgs_goal = h101InputForm.sdgs_goal.toString();
      // カテゴリ
      h101InputForm.category = h101InputForm.category.toString();
      // 事例タグ
      h101InputForm.case_tag = h101InputForm.case_tag.toString();
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    /* 共通バリデーションチェック */
    this.dbOperationService
      .multiValidationResult('cooperation', h101InputForm)
      .subscribe((response) => {
        let errorFlg = false;

        if (response.body[0].result == 0) {
          // エラー無しの場合、チェックを実施しない
        } else {
          // 必須チェック

          // key: カラム, value: エラーメッセージ
          for (let [key, value] of Object.entries(response.body[0].message)) {
            let val = value.toString();
            // 必須以外のエラーがあればエラー判定(タイトルの必須チェックは有効)
            if (key != undefined && key != CONSTANT.EMPTY_STRING) {
              if (
                val.indexOf('必須') == -1 ||
                (key == 'title' && val.indexOf('必須') != -1)
              ) {
                // 異常終了メッセージ
                this.messageData.toastMessage(
                  new ToastMessageData({
                    severity: TOAST.ERROR,
                    summary: this.columnName[key],
                    detail: val,
                  })
                );
                // エラー判定の場合、フラグを立てる
                errorFlg ||= true;
              }
            }
          }
        }
        // エラー判定
        if (!errorFlg) {
          // 登録処理

          // 登録タイプ判定
          if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
            // 新規登録の場合

            // 会員ID
            h101InputForm.member_id = this.getLoginMemberId();

            // 連携事例登録を実施
            this.dbOperationService
              .insertData(COOPERATIONS, h101InputForm)
              .subscribe((response) => {
                // 画面ロードフラグをOFF(ロード終了)
                this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

                // レスポンス結果を判定
                if (API_RESPONSE.SUCCESS == response.body.Message) {
                  // 正常終了の場合

                  // 連携事例詳細(H301)へ遷移
                  this.router.navigate([
                    'pages/platform/h301/' + response.body.cooperation_id,
                  ]);
                } else {
                  // 異常終了の場合

                  // 異常終了メッセージ
                  this.messageData.toastMessage(
                    new ToastMessageData({
                      severity: TOAST.ERROR,
                      summary: this.commonService.msg(MESSAGE_CODE.E00001),
                      detail: this.commonService.msg(MESSAGE_CODE.E80002),
                    })
                  );
                }
              });
          } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
            // 編集の場合
            // 会員ID
            h101InputForm.member_id = this.getLoginMemberId();

            // 連携事例ID
            h101InputForm.cooperationId = this.cooperationId;

            // 連携事例更新を実施
            this.dbOperationService
              .updateData(COOPERATION_UPLOAD, this.cooperationId, h101InputForm)
              .subscribe((response) => {
                // 画面ロードフラグをOFF(ロード終了)
                this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

                // レスポンス結果を判定
                if (API_RESPONSE.SUCCESS == response.body.Message) {
                  // 正常終了の場合

                  // 連携事例詳細(H301)へ遷移
                  this.router.navigate([
                    'pages/platform/h301/' + this.cooperationId,
                  ]);
                } else {
                  // 異常終了の場合

                  // 異常終了メッセージ
                  this.messageData.toastMessage(
                    new ToastMessageData({
                      severity: TOAST.ERROR,
                      summary: this.commonService.msg(MESSAGE_CODE.E00001),
                      detail: this.commonService.msg(MESSAGE_CODE.E80002),
                    })
                  );
                }
              });
          }
        } else {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);
        }
      });
  }

  // 図・写真① 必須入力判定
  public checkRequiredImg1() {
    // 画像ID取得
    let screenId = this.h101InputForm.get('case_image1').value;
    if (screenId == null || screenId.length == 0) {
      // エラーメッセージ上書き
      this.h101InputForm.controls['case_image1'].setErrors({
        message: '図・写真①は必須添付です。',
      });
    } else {
      // エラーメッセージ設定
      this.h101InputForm.controls['case_image1'].setErrors(null);
    }
  }

  /**
   * 画像タイトル必須入力判定
   * @param formName フォーム項目名
   */
  public checkRequiredImgCaption(formName: string) {
    // 画像ID取得
    let screenId = this.h101InputForm.get(formName).value;
    // 画像IDが存在するか判定
    if (screenId != null && screenId.length != 0) {
      // 担当者関連の場合
      if (formName == 'responsible_person_image') {
        // 担当者コメント, タイトルを取得
        let person_comment = this.h101InputForm.get(
          'responsible_person_comment'
        ).value;
        let person_caption = this.h101InputForm.get(
          'responsible_person_caption'
        ).value;
        // 担当者コメントが入力済みか判定
        if (
          person_comment == null ||
          person_comment.length == 0 ||
          person_comment == CONSTANT.EMPTY_STRING
        ) {
          // 未入力の場合

          // メッセージを表示させるために対象項目をマーク
          this.h101InputForm.controls[
            'responsible_person_comment'
          ].markAsDirty();
          // エラーメッセージ設定
          this.h101InputForm.controls['responsible_person_comment'].setErrors({
            message: '必須項目です。必ず入力してください。',
          });
        }
        if (
          person_caption == null ||
          person_caption.length == 0 ||
          person_caption == CONSTANT.EMPTY_STRING
        ) {
          // 未入力の場合

          // メッセージを表示させるために対象項目をマーク
          this.h101InputForm.controls[
            'responsible_person_caption'
          ].markAsDirty();
          // エラーメッセージ設定
          this.h101InputForm.controls['responsible_person_caption'].setErrors({
            message: '必須項目です。必ず入力してください。',
          });
        }
      } else {
        // タイトルを取得
        let caption = this.h101InputForm.get(formName + '_caption').value;
        // タイトルが入力済みか判定
        if (
          caption == null ||
          caption.length == 0 ||
          caption == CONSTANT.EMPTY_STRING
        ) {
          // 未入力の場合

          // メッセージを表示させるために対象項目をマーク
          this.h101InputForm.controls[formName + '_caption'].markAsDirty();
          // エラーメッセージ設定
          this.h101InputForm.controls[formName + '_caption'].setErrors({
            message: '必須項目です。必ず入力してください。',
          });
        }
      }
    } else {
      // 画像IDが無い場合は 必須入力解除
      // 担当者関連項目かを判定
      if (formName == 'responsible_person_image') {
        // 担当者関連の場合
        this.h101InputForm.controls['responsible_person_comment'].setErrors(
          null
        );
        this.h101InputForm.controls['responsible_person_caption'].setErrors(
          null
        );
      } else {
        // それ以外の場合
        this.h101InputForm.controls[formName + '_caption'].setErrors(null);
      }
    }
  }

  /**
   * 初期画像IDフラグの削除
   * @param formName フォーム項目名
   */
  public breakImgCaptionFlg(formName: string): void {
    // フラグを折る
    if (this.caseImgId1 && formName == 'case_image1') {
      this.caseImgId1 = false;
    }
    if (this.caseImgId2 && formName == 'case_image2') {
      this.caseImgId2 = false;
    }
    if (this.overviewImgId1 && formName == 'overview_image1') {
      this.overviewImgId1 = false;
    }
    if (this.overviewImgId2 && formName == 'overview_image2') {
      this.overviewImgId2 = false;
    }
    if (this.responsiblePersonImgId && formName == 'responsible_person_image') {
      this.responsiblePersonImgId = false;
    }
  }

  // 未入力項目にエラーメッセージを表示
  private displayRequiredError(){
    for (let key in this.requiredName){
      let keyValue = this.h101InputForm.get(key).value;
        // 未入力の場合
      if (
        keyValue == null ||
        keyValue.length == 0 ||
        keyValue == CONSTANT.EMPTY_STRING
      ) {
         // メッセージを表示させるために対象項目をマーク
         this.h101InputForm.controls[key].markAsDirty();
         // エラーメッセージ設定
         this.h101InputForm.controls[key].setErrors({
          message: '必須項目です。必ず入力してください。',
       });
      }
    }
  }
}
